import type { DraggableMetaType, FieldWrapper, ReportField } from "../../../../../../../../../api/types/svTypes.ts";
import { AreaItemType } from "../../../../../../../../../api/types/svTypes.ts";
import { extractMeta } from "../../../common/utilities/dropFieldContainerHelper.ts";
import { canDropItemBase } from "../canDropHelper.ts";

export const MaxColsNumber = 5;

export const canDropColumnItem = (
  item: FieldWrapper<ReportField> | DraggableMetaType,
  columns: ReportField[],
  rows: ReportField[]
): boolean => {
  const meta = extractMeta(item);
  if (!meta) {
    return false;
  }
  if (columns.length >= MaxColsNumber) {
    return false;
  }

  if (item.type === AreaItemType.ROWS) {
    return !columns.some((f) => f.meta.name === meta.name);
  }

  return canDropItemBase(item, rows, columns);
};
